import {
  ACTION_MULTIPLE,
  CART_ADD_ITEM,
  CART_LOAD_FROM_LOCAL_STORAGE,
  CART_REMOVE_ITEM,
  CART_TO_LOCAL_STORAGE
} from "../utils/Constant";

/**
 *
 * @param item
 * @returns {{type: string, actions: *[], data: {item: *}}}
 */
export function add(item) {
  return {
    type: ACTION_MULTIPLE,
    actions: [CART_ADD_ITEM, CART_TO_LOCAL_STORAGE],
    data: {item}
  };
}
/**
 * @param id
 * @returns {{type: string}}
 */
export function remove(id) {
  return {
    type: ACTION_MULTIPLE,
    actions: [CART_REMOVE_ITEM, CART_TO_LOCAL_STORAGE],
    data: {id}
  };
}


/**
 *
 * @returns {{type: string}}
 */
export function loadCartFromLocalStore() {
  return {
    type: CART_LOAD_FROM_LOCAL_STORAGE,
  };
}


